import React from 'react';
import styled from 'styled-components';

import { Tabs, Tab, Typography } from '@material-ui/core/';

import FeatureImage from '../../../assets/produkt-grafiken-all-products-white.jpg';

const Root = styled.div`
	img {
		max-width: 100%;
		height: auto;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
		text-transform: uppercase;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}

	.tab-text {
		padding: 20px;
	}
`;

const FeatureImageContainer = styled.div`
	background-image: url(${FeatureImage});
	background-size: cover;
	background-position: center center;
	min-height: 523px;
	overflow: auto;
`;

export function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{value === index && <>{children}</>}
		</div>
	);
}

const ContentPowerMarketing = () => {
	const [value, setValue] = React.useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Root>
			<Tabs value={value} onChange={handleChange} variant="fullWidth">
				<Tab className="menuTab" label="Abbildung" />
				<Tab className="menuTab" label="Informationen" />
			</Tabs>
			<TabPanel value={value} index={0}>
				<FeatureImageContainer />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<div className="tab-text">
					<Typography variant="h6">
						Okean.OS – mehr Flexibilität für mehr Möglichkeiten
					</Typography>
					<Typography>
						Ihr Speicher arbeitet für Sie und spart Ihnen richtig Geld. Das
						ist gut so, aber wie wäre es, wenn er nebenbei – sozusagen in
						seiner Freizeit – Geld für Sie verdient? Genau dafür entwickeln
						wir <strong>okean.OS</strong>, das Betriebssystem für Ihre Anlage.
						<strong>okean.OS</strong> sorgt dafür, dass Ihr Speicher immer
						genau zum richtigen Zeitpunkt mit genau der richtigen Menge an
						Strom geladen wird, damit er Ihren Bedarf decken kann.
					</Typography>
					<Typography>
						Woher weiß <strong>okean.OS</strong> das? Es hat gelernt – und
						zwar von Ihrem Verbrauchsverhalten. Dadurch weiß es ganz genau,
						was Sie in den nächsten 48 Stunden benötigen und kann die Lade-
						und Entladezyklen exakt planen. Außerdem berücksichtigt es bei
						seiner Berechnung Wetter- und Energiemarktdaten sowie Daten über
						das Stromnetz.
					</Typography>
					<Typography>
						Und was haben Sie davon? Ganz einfach: Flexibilität, um den
						Speicher auch anderweitig zu nutzen, z.B. als Anbieter von
						Flexibilität im Energiesystem. Denn in der Zeit, in der der
						Speicher nicht für Sie arbeitet, kann er an der Transformation zum
						dezentralen Energiesystem mitwirken und Dank unserer Marktzugänge
						für Sie bares Geld verdienen.
					</Typography>
				</div>
			</TabPanel>
		</Root>
	);
};

export default ContentPowerMarketing;
